import { useState } from 'react';
import { Trash } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteUserDeliveryAddress } from '../../../../../api/user-api';
import { UpdateDeliveryAddressModal } from './UpdateDeliveryAddressModal';
import {
  deleteDeliveryAddress,
  selectDeliveryAddress,
  setDeliveryAddress,
} from '../../../../../features/order/deliveryAddressSlice';

export const SingleDeliveryAddressBox = ({
  address,
  onSelectedAddress,
  selectedAddressId,
}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const addr = useSelector(selectDeliveryAddress);

  // Mutation for deleting an address
  const deleteAddressMutation = useMutation({
    mutationFn: (id) => deleteUserDeliveryAddress(id),
    onSuccess: (_, deletedId) => {
      queryClient.invalidateQueries(['useraddresses']);
      dispatch(deleteDeliveryAddress(deletedId));
    },
  });

  const handleDelete = (id) => {
    deleteAddressMutation.mutate(id);
  };

  const handleSelectAddress = (address) => {
    // update Redux store
    dispatch(setDeliveryAddress(address));
    // call parent handler if needed
    if (onSelectedAddress) onSelectedAddress(address);
  };

  return (
    <div className="border border-[#DEDEDE] rounded-[5px] font-medium font-duplet text-sm p-4 flex justify-between md:w-[345px] h-[95px]">
      <div>
        <p className="text-balance max-w-[206px]">{address?.streetAddress}</p>
        <p>{address?.state}</p>
      </div>

      <div className="flex flex-col justify-between items-end">
        <input
          type="radio"
          name="delivery-address"
          className="accent-black cursor-pointer"
          checked={selectedAddressId === address.id || addr?.id === address.id}
          // checked={addr?.id === address.id}
          onChange={() => handleSelectAddress(address)}
        />

        <div className="flex space-x-3">
          {/* Edit Button */}
          <button
            className="underline font-normal"
            onClick={() => setIsModalOpen(true)}
          >
            Edit
          </button>

          {/* Edit Modal */}
          {isModalOpen && (
            <UpdateDeliveryAddressModal
              onClose={() => setIsModalOpen(false)}
              address={address}
            />
          )}

          {/* Delete Button */}
          <button
            type="button"
            onClick={() => handleDelete(address.id)}
            disabled={deleteAddressMutation.isPending}
          >
            {deleteAddressMutation.isPending ? (
              <span className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin inline-block" />
            ) : (
              <Trash />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
